import { useMutation, useQueryClient } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import { appExclusiveScheduleQueryKeys } from './useGetAppExclusiveSchedules';
import { offerQueryKeys } from './useGetOffer';

export interface DeleteAppExclusiveScheduleInput {
  offerId: string;
  scheduleId: number;
}

export function useDeleteAppExclusiveSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ offerId, scheduleId }: DeleteAppExclusiveScheduleInput) =>
      OffersService.deleteSchedule(offerId, scheduleId),
    onSuccess: (_data, { offerId }) => {
      // Frees the day(s) in the calendar and in the eligible lookup, which share this root key.
      queryClient.invalidateQueries({ queryKey: appExclusiveScheduleQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: offerQueryKeys.detail(offerId) });
    },
  });
}
